<template>
  <v-text-field
    :style="{'width': width?(width+'px'):'auto'}"
    ref="currencyField"
    v-model="formattedValue"
    type="tel"
    @input="change"
    @blur="focusExit"
    @focus="focusEnter"
    @keydown="keydown"
    v-bind="$props"
    :class="classes"
  >

  </v-text-field>
</template>

<script>
  export default {
    name: "VCurrencyField",
    props: {
      value: {
        required: true,
        type: [Number, String],
        default: 0
      },
      placeholder: String,
      outlined: Boolean,
      classes: String,
      width: Number,
      disabled: Boolean,
      filled: {
        type: Boolean,
        default: false,
      },
      hideDetails: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      formattedValue: '',
      inFocus: false
    }),
    computed: {},
    methods: {
      getNumbers(value) {
        return value && value.toString().replace(/\D+/g, '') || '0'
      },
      numbersToCurrency(value, precision = 2) {
        return value && parseFloat(value).toFixed(precision) || '0.00';
      },
      unFormat(value) {
        let parts = value.toString().replace(',', '.').split('.');
        return this.numbersToCurrency(this.getNumbers(parts[0]) + '.' + this.getNumbers(parts[1])).toString().replace('.', ',');
      },
      format(value, precision = 2) {
        value = value.toString().replace(',', '.');
        let currency = this.numbersToCurrency(value);
        let parts = currency.toString().split('.');

        return this.addThousandSeparator(parts[0]) + ',' + parts[1];
      },
      addThousandSeparator(integer, separator = ' ') {
        return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`);
      },
      change(newVal) {
        this.$emit('input', this.unFormat(newVal).replace(',', '.'));
      },
      focusExit(value) {
        this.inFocus = false;
        this.formattedValue = this.format(this.formattedValue);
      },
      focusEnter(value) {
        this.inFocus = true;
        this.formattedValue = this.unFormat(this.formattedValue);
      },
      isNumber(value) {
        return /^\d+$/.test(value);
      },
      isCorrectChar(key) {
        return ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(key) || [',', '.'].includes(key) && !this.formattedValue.includes(key);
      },
      keydown(event) {
        if (!this.isCorrectChar(event.key) && !this.isNumber(event.key)) {
          event.preventDefault();
        }
      }
    },
    watch: {
      value: {
        immediate: true,
        handler(value) {
          if (+value < 0) value = 0;

          if (!this.inFocus) {
            this.formattedValue = this.format(value);
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
